export const EOdrSearchStatus = {
   0: "UNKNOWN",
   1: "STARTED",
   2: "COMPLETED",
   3: "ORDERED",
   4: "ERROR",
   "-1": "ALL",
};

export const EOdrOrderStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "ISSUED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REISSUED",
   8: "ERROR",
   9: "OPEN",
   10: "PENDING_ISSUED",
   11: "PENDING_RESERVED",
   12: "PENDING_CANCELED",
   13: "PENDING_VOIDED",
   14: "PENDING_REFUNDED",
   15: "PARTIAL_PAID",
   "-1": "ALL",
};

export const EOdrType = {
   0: "UNKNOWN",
   1: "FLIGHT",
   2: "HOTEL",
   3: "TRANSFER",
   4: "RENTACAR",
   5: "PACKAGE",
   "-1": "ALL",
};

export const EOdrEntityType = {
   0: "UNKNOWN",
   1: "PAYMENT",
   2: "PNR",
   3: "HOTEL",
   4: "TRANSFER",
   5: "RENT_A_CAR",
   6: "INVOICE",
   7: "INSURANCE",
   "-1": "ALL",
};

export const EOdrSubEntityType = {
   0: "UNKNOWN",
   1: "PRIMARY",
   2: "SECONDARY",
   "-1": "ALL",
};

export const EOdrImportType = {
   0: "UNKNOWN",
   1: "AUTO",
   2: "MANUAL",
   3: "CRON",
   "-1": "ALL",
};

export const EOdrErrorType = {
   0: "UNKNOWN",
   1: "PAYMENT",
   2: "FLIGHT",
   3: "HOTEL",
   4: "TRANSFER",
   5: "RENTACAR",
   "-1": "ALL",
};

export const EOdrTrxType = {
   0: "UNKNOWN",
   1: "CHECKOUT",
   2: "RESERVE",
   3: "TICKET",
   4: "REVERSE",
   5: "LEAVE",
   6: "INQUIRY",
   "-1": "ALL",
};

export const EOdrSearchHotelDateType = {
   0: "UNKNOWN",
   1: "PROCESS",
   2: "CHECKIN",
   "-1": "ALL",
};

export const EOdrSearchTransferDateType = {
   0: "UNKNOWN",
   1: "PROCESS",
   2: "PICKUP",
   "-1": "ALL",
};

export const EOdrSearchRentACarDateType = {
   0: "UNKNOWN",
   1: "PROCESS",
   2: "PICKUP",
   "-1": "ALL",
};

export const EOdrConfirmationSource = {
   0: "UNKNOWN",
   1: "GTS",
   2: "HOTEL_RUNNER",
   "-1": "ALL",
};
